import { Component } from '@angular/core';
import { LayoutService } from './modules/layout/state/layout.service';
import { LayoutQuery } from './modules/layout/state/layout.query';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
  standalone: false,
})
export class AppComponent {
  title = 'Facility Management System';

  constructor(
    private layoutService: LayoutService,
    public layoutQuery: LayoutQuery
  ) {
    this.layoutService.setDirection();
  }
}
